import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../context/LanguageContext';

const SEO = ({ 
  title, 
  description, 
  keywords,
  ogImage = 'https://instant-email.org/og-image.png',
  path = '',
  useTranslation = false
}) => {
  const { t, currentLanguage, getLocalizedPath } = useLanguage();
  const siteUrl = 'https://instant-email.org';
  
  // Use translations if specified
  const finalTitle = useTranslation 
    ? (title ? `${t(title)} | Instant-Email` : t('meta.title'))
    : (title ? `${title} | Instant-Email` : 'Instant-Email - Free Temporary Disposable Email Address');
  
  const finalDescription = useTranslation && description ? t(description) : description || t('meta.description');
  const finalKeywords = useTranslation && keywords ? t(keywords) : keywords || t('meta.keywords');
  
  // Create localized URL
  const localizedPath = getLocalizedPath(path);
  const fullUrl = `${siteUrl}${localizedPath}`;
  
  // Language alternates
  const alternateLanguages = ['en', 'fr', 'de', 'es'];

  return (
    <Helmet>
      <html lang={currentLanguage} />
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      {finalKeywords && <meta name="keywords" content={finalKeywords} />}
      <link rel="canonical" href={fullUrl} />
      
      {/* Language alternates */}
      {alternateLanguages.map(lang => (
        <link 
          key={lang}
          rel="alternate" 
          hrefLang={lang} 
          href={`${siteUrl}${lang === 'en' ? path : `/${lang}${path}`}`} 
        />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${siteUrl}${path}`} />
      
      {/* Open Graph */}
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={currentLanguage === 'en' ? 'en_US' : `${currentLanguage}_${currentLanguage.toUpperCase()}`} />
      {alternateLanguages.filter(lang => lang !== currentLanguage).map(lang => (
        <meta key={lang} property="og:locale:alternate" content={lang === 'en' ? 'en_US' : `${lang}_${lang.toUpperCase()}`} />
      ))}
      
      {/* Twitter Card */}
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
